import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	blockContent: [
		{
			question: 'Какво е Shopiko?',
			answer: `
					 <p>Shopiko от Superhosting е платформа от типа SaaS (Software as a Service) за създаване на онлайн магазин без нужда от технически умения. 
					 С нея можете бързо и лесно да изградите и управлявате своя онлайн бизнес – от продуктовия каталог до поръчките и плащанията. 
					 Платформата предлага готови дизайни, интеграции с куриери и разплащания, както и автоматизирани функции за маркетинг и управление.</p>
					`
		},
		{
			question: 'Мога ли да тествам услугата?',
			answer: `
					<p>Да, можеш напълно безплатно да тестваш Shopiko за 14 дни. 
					В този период ще имаш достъп до всички функции, за да се увериш дали платформата отговаря на нуждите на твоя онлайн бизнес. 
					Не се изисква плащане или въвеждане на картови данни. 
					След изтичането на тестовия период, можеш да избереш подходящ план и да активираш магазина си. 
					Още през тестовия период магазинът ти ще бъде онлайн и ще можеш да реализираш продажби.</p>
					`
		},
		{
			question: 'За кого е подходяща услугата Shopiko?',
			answer: `
					<p>Shopiko е подходяща за всеки, който иска бързо и лесно да започне да продава онлайн – без нужда от програмиране или специални технически умения. 
					Идеална е за малки и средни бизнеси, за творци, производители, бутик брандове и физически магазини, които искат да се дигитализират. 
					Платформата осигурява всичко необходимо за онлайн търговия – от продуктов каталог и разплащания до доставки и маркетинг.</p>
					`
		},
		{
			question: 'Има ли включен хостинг в услугата?',
			answer: `
					<p>Да, хостингът е включен в услугата Shopiko. 
					Не е нужно да закупувате отделен хостинг план – всичко необходимо за работата на твоя онлайн магазин е осигурено в платформата. 
					Това ти спестява време, средства и технически ангажименти.</p>
					`
		},
		{
			question: 'Имам ли включен SSL сертификат на сайта?',
			answer: `
					<p>За всички сайтове има инсталиран SSL сертификат.</p>
					`
		},
		{
			question: 'Ще мога ли да си създам пощенски кутии?',
			answer: `
					<p>Разбира се. В зависимост от избрания план можеш да създадеш необходимия брой пощенски кутии. 
					Пощенски кутии можеш да създаваш и управляваш директно през клиентския си профил в superhosting.bg. 
					За да създадеш нова пощенска кутия, влез в своя клиентски профил и избери Шопико » Детайли » Пощи » Създай пощенска кутия.</p>
					`
		},
		{
			question: 'Обслужването на български език ли е?',
			answer: `
					<p>Да, цялото обслужване на Shopiko е на български език. 
					Експерите са на разположение да съдействат по имейл или телефон. 
					Освен това, админ панелът и помощната документация също са на български, за максимално удобство.</p>
					`
		},
		{
			question: 'Предлагате ли съдействие при настройването на онлайн магазин с Shopiko?',
			answer: `
					<p>
					Да. Съдействаме с насоки и настройки, които ще ти помогнат да стартираш своя онлайн магазин с Shopiko по-бързо и лесно. 
					Можем да помогнем при настройването на куриерски модули и платежни методи, избора на подходящ дизайн, както и да дадем препоръки за структурата и организацията на магазина.
					</p>
					<p>Целта ни е да улесним процеса и да ти помогнем да изградиш магазин, който е удобен както за теб, така и за твоите клиенти.</p>
					`
		},
		{
			question: 'С кои куриерски фирми предлагате интеграция?',
			answer: `
					<p>Shopiko предлага готова интеграция с водещите куриерски фирми в България – Еконт, Спиди, euShipments и BoxNow. 
					Това ти позволява лесно да генерираш товарителници, да избираш методи за доставка и да улесняваш клиентите си при поръчка. 
					Всичко се управлява директно от админ панела на магазина ви.</p>
					`
		},
		{
			question: 'С кои разплащателни методи има интеграция Shopiko?',
			answer: `
					<p>Shopiko поддържа интеграция с най-популярните разплащателни методи – плащане при доставка (наложен платеж), банков превод, плащане с карта, както и онлайн разплащания чрез Stripe, PayPal, Revolut, myPos и еPay. 
					Можеш да предложиш удобни и сигурни опции за твоите клиенти, като активираш само тези, които са най-подходящи за твоя магазин.</p>
					`
		},
		{
			question: 'Мога ли да интегрирам продуктов каталог с рекламните платформи на Google и Facebook?',
			answer: `
					<p>Да, Shopiko позволява лесна интеграция на продуктовия каталог с рекламни платформи като Google Ads и Facebook Ads. 
					Това ти дава възможност да създаваш ефективни реклами и да достигаш точно до твоята целева аудитория директно с продуктите от магазина ти.</p>
					`
		},
		{
			question: 'Какви периоди се предлагат за плановете?',
			answer: `
					<p>Предлагат се два периода - 1 месец или 1 година. При годишен план получаваш допълнителна отстъпка.</p>
					`
		},
		{
			question: 'Мога ли да ъпгрейдвам плана си?',
			answer: `
					<p>Да, можеш да направиш ъпгрейд по всяко време в рамките на текущия период. 
					При промяна към по-висок план се заплаща само разликата в цената за подновяване между двата плана за оставащия период от време.</p>
					`
		},
		{
			question: 'Има ли включена мобилна версия на магазина?',
			answer: `
					<p>Да, всеки магазин в Shopiko има налична мобилна версия. 
					Можеш да избереш между респонсив дизайн (адаптивен към различни устройства) или специализирана мобилна версия. 
					Това осигурява оптимално потребителско изживяване както на компютър, така и на телефон или таблет.</p>
					`
		}
	]
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockContent: [
		{
			question: 'What is Shopiko?',
			answer: `
					 <p>Shopiko by superhosting.bg is a SaaS platform (Software as a Service) that lets you create your own online store with no technical skills needed.</p>
					 <p>You can easily build, customize, and manage every part of your eCommerce business — from your product catalog to orders and payments.</p>
					 <p>Shopiko includes modern store designs, built-in courier and payment integrations, and automated tools for marketing and store management.</p>
					`
		},
		{
			question: 'Can I try Shopiko for free?',
			answer: `
					<p>Yes! You can try Shopiko free for 14 days with full access to all features — no credit card required. 
					During your trial, your store will be online, so you can test everything and even make real sales. 
					Once the trial ends, simply choose a plan that fits your needs and keep selling without interruption.</p>
					`
		},
		{
			question: 'Who is Shopiko suitable for?',
			answer: `
					<p>Shopiko is built for entrepreneurs, creators, and small to medium-sized businesses who want to start selling online quickly and easily. 
					It’s perfect for boutique brands, local shops, artisans, and manufacturers who want to grow their business digitally — without coding or complex setup. 
					From catalog management and payments to shipping and marketing, Shopiko provides everything you need to sell online successfully.</p>
					`
		},
		{
			question: 'Is hosting included?',
			answer: `
					<p>Yes! Secure hosting is included with every Shopiko plan and you don’t need to purchase separate hosting.</p>
					<p>Your online store runs on reliable infrastructure, saving you time, money, and technical effort.</p>
					`
		},
		{
			question: 'Does my website include an SSL certificate?',
			answer: `
					<p>Yes. Every Shopiko store comes with an SSL certificate pre-installed, ensuring a secure, encrypted connection for you and your customers.</p>
					`
		},
		{
			question: 'Can I create email accounts?',
			answer: `
					<p>Absolutely. Depending on your plan, you can create and manage multiple email addresses directly from your superhosting.bg client profile.</p>
					<p>To create a new mailbox: go to your client profile → Shopiko → Details → Mail → Create mailbox.</p>
					`
		},
		{
			question: 'Is customer support available in Bulgarian?',
			answer: `
					<p>Yes. Our entire Shopiko support team is based in Bulgaria and available via email or phone.</p>
					<p>Both the admin panel and help documentation are also in Bulgarian for your convenience.</p>
					`
		},
		{
			question: 'Do you offer assistance with setting up an online store with Shopiko?',
			answer: `
					<p>
					Yes. We provide guidance and assistance with settings to help you launch your online store with Shopiko faster and more easily. 
					We can help with setting up courier modules and payment methods, choosing a suitable design, as well as provide recommendations on the store’s structure and organization.
					</p>
					<p>Our goal is to make the process easier and help you build a store that is convenient both for you and your customers.</p>
					`
		},
		{
			question: 'Which courier services does Shopiko integrate with?',
			answer: `
					<p>Shopiko offers built-in integrations with Bulgaria’s leading courier companies — Econt, Speedy, euShipments, and BoxNow.</p>
					<p>You can easily generate shipping labels, manage delivery options, and streamline order fulfillment — all from your store’s admin panel.</p>
					`
		},
		{
			question: 'Which payment methods are supported?',
			answer: `
					<p>Shopiko supports the most popular payment methods, including:</p>
					<p>
					- Cash on delivery <br/>
					- Bank transfer <br/>
					- Card payments <br/>
					- Online gateways like Stripe, PayPal, Revolut, myPOS, and ePay
					</p>
					<p>Activate the payment options that work best for your business and give your customers a fast, secure checkout experience.</p>
					`
		},
		{
			question: 'Can I connect my product catalog to Google and Facebook Ads?',
			answer: `
					<p>Yes. You can easily sync your product catalog with Google Ads and Facebook Ads to run targeted campaigns and reach your ideal customers with your products.</p>
					`
		},
		{
			question: 'What billing periods are available?',
			answer: `
					<p>You can choose between monthly or annual billing. Annual plans come with an extra discount.</p>
					`
		},
		{
			question: 'Can I upgrade my plan?',
			answer: `
					<p>Yes. You can upgrade at any time.
					When moving to a higher plan, you’ll only pay the price difference for the remaining period.</p>
					`
		},
		{
			question: 'Does my store include a mobile version?',
			answer: `
					<p>Yes. Every Shopiko store includes a mobile-optimized version.
					You can choose between a responsive design (that adapts to all devices) or a dedicated mobile layout, ensuring the best shopping experience across desktop, tablet, and mobile.</p>
					`
		}
	]
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];